import { useState } from "react";
import websocketService from "services/websocket";

export const usePlaceOrder = () => {
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);
  const [orderInProgress, setOrderInProgress] = useState<"buy" | "sell" | null>(
    null,
  );

  const placeOrder = async (
    pair: string | null,
    direction: "buy" | "sell",
    amount: number,
    duration: number,
  ) => {
    if (!pair || isPlacingOrder) return;

    setIsPlacingOrder(true);
    setOrderInProgress(direction);

    try {
      const wsDirection = direction === "buy" ? "call" : "put";

      websocketService.placeOrder(pair, wsDirection, amount, duration);

      setTimeout(() => {
        setIsPlacingOrder(false);
        setOrderInProgress(null);
      }, 1000);
    } catch {
      setIsPlacingOrder(false);
      setOrderInProgress(null);
    }
  };

  return {
    placeOrder,
    isPlacingOrder,
    orderInProgress,
  };
};
